import { Companion_getInstance3fqqrg13gcz0e as Companion_getInstance } from './proofs/OtpHashAlgorithm.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { IndexSetppgakdbfpe00 as IndexSet } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/Annotations.mjs';
import {
  UuidSerializer_getInstance1ib26ji9vwcd4 as UuidSerializer_getInstance,
  DurationSerializer_getInstance24c8qta2pbnpd as DurationSerializer_getInstance,
  InstantSerializer_getInstance1n2pd669tdsta as InstantSerializer_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import {
  Duration5ynfiptaqcrg as Duration,
  Duration__toString_impl_8d916b1pmuuqkmfodll as Duration__toString_impl_8d916b,
  Duration__hashCode_impl_u4exz62capomnnb6e8m as Duration__hashCode_impl_u4exz6,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance,
  IntSerializer_getInstance3jyhns9ue706g as IntSerializer_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { HasId24qpfucecockd as HasId } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/HasId.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function TotpSecret$Companion$$childSerializers$_anonymous__thikpv() {
  return Companion_getInstance().serializer_9w0wvi_k$();
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, null, null, null, null, null, lazy(tmp_0, TotpSecret$Companion$$childSerializers$_anonymous__thikpv), null, null, null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_1() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.TotpSecret', this, 13);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('subjectType', false);
        tmp0_serialDesc.addElement_5pzumi_k$('subjectId', false);
        tmp0_serialDesc.addElement_5pzumi_k$('label', false);
        tmp0_serialDesc.addElement_5pzumi_k$('secretBase32', false);
        tmp0_serialDesc.addElement_5pzumi_k$('issuer', false);
        tmp0_serialDesc.addElement_5pzumi_k$('period', false);
        tmp0_serialDesc.addElement_5pzumi_k$('digits', false);
        tmp0_serialDesc.addElement_5pzumi_k$('algorithm', false);
        tmp0_serialDesc.addElement_5pzumi_k$('establishedAt', false);
        tmp0_serialDesc.addElement_5pzumi_k$('lastUsedAt', true);
        tmp0_serialDesc.addElement_5pzumi_k$('expiresAt', true);
        tmp0_serialDesc.addElement_5pzumi_k$('disabledAt', true);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (IndexSet())(['subjectId', 'subjectType', 'expiresAt', 'disabledAt']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_gjphy6_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_1().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !value._id_1.equals(Companion_getInstance_0().random_fimq0t_k$())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, UuidSerializer_getInstance(), value._id_1);
        }
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.subjectType_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.subjectId_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 3, value.label_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 4, value.secretBase32__1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 5, value.issuer_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 6, DurationSerializer_getInstance(), new (Duration())(value.period_1));
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 7, value.digits_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 8, tmp2_cached[8].get_value_j01efc_k$(), value.algorithm_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 9, InstantSerializer_getInstance(), value.establishedAt_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 10) ? true : !(value.lastUsedAt_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 10, InstantSerializer_getInstance(), value.lastUsedAt_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 11) ? true : !(value.expiresAt_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 11, InstantSerializer_getInstance(), value.expiresAt_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 12) ? true : !(value.disabledAt_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 12, InstantSerializer_getInstance(), value.disabledAt_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_gjphy6_k$(encoder, value instanceof TotpSecret() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = 0;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp18_cached = Companion_getInstance_1().$childSerializers_1;
        if (tmp17_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, UuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp17_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp17_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp17_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp17_input.decodeStringElement_3oenpg_k$(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp17_input.decodeStringElement_3oenpg_k$(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          var tmp = DurationSerializer_getInstance();
          var tmp_0 = tmp10_local6;
          var tmp_1 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp, tmp_0 == null ? null : new (Duration())(tmp_0));
          tmp10_local6 = tmp_1 == null ? null : tmp_1.rawValue_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp17_input.decodeIntElement_941u6a_k$(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 8, tmp18_cached[8].get_value_j01efc_k$(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 9, InstantSerializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp17_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 10, InstantSerializer_getInstance(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp17_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 11, InstantSerializer_getInstance(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp17_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 12, InstantSerializer_getInstance(), tmp16_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp17_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, UuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp17_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp17_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp17_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp17_input.decodeStringElement_3oenpg_k$(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp17_input.decodeStringElement_3oenpg_k$(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                var tmp_2 = DurationSerializer_getInstance();
                var tmp_3 = tmp10_local6;
                var tmp_4 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp_2, tmp_3 == null ? null : new (Duration())(tmp_3));
                tmp10_local6 = tmp_4 == null ? null : tmp_4.rawValue_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp17_input.decodeIntElement_941u6a_k$(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 8, tmp18_cached[8].get_value_j01efc_k$(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp17_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 9, InstantSerializer_getInstance(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp17_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 10, InstantSerializer_getInstance(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp17_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 11, InstantSerializer_getInstance(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp17_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 12, InstantSerializer_getInstance(), tmp16_local12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp17_input.endStructure_1xqz0n_k$(tmp0_desc);
        return TotpSecret().new_com_lightningkite_lightningserver_sessions_TotpSecret_rc92bb_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_1().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), DurationSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[8].get_value_j01efc_k$(), InstantSerializer_getInstance(), get_nullable(InstantSerializer_getInstance()), get_nullable(InstantSerializer_getInstance()), get_nullable(InstantSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var TotpSecretClass;
function TotpSecret() {
  if (TotpSecretClass === VOID) {
    class $ {
      constructor(_id, subjectType, subjectId, label, secretBase32, issuer, period, digits, algorithm, establishedAt, lastUsedAt, expiresAt, disabledAt) {
        Companion_getInstance_1();
        _id = _id === VOID ? Companion_getInstance_0().random_fimq0t_k$() : _id;
        lastUsedAt = lastUsedAt === VOID ? null : lastUsedAt;
        expiresAt = expiresAt === VOID ? null : expiresAt;
        disabledAt = disabledAt === VOID ? null : disabledAt;
        this._id_1 = _id;
        this.subjectType_1 = subjectType;
        this.subjectId_1 = subjectId;
        this.label_1 = label;
        this.secretBase32__1 = secretBase32;
        this.issuer_1 = issuer;
        this.period_1 = period;
        this.digits_1 = digits;
        this.algorithm_1 = algorithm;
        this.establishedAt_1 = establishedAt;
        this.lastUsedAt_1 = lastUsedAt;
        this.expiresAt_1 = expiresAt;
        this.disabledAt_1 = disabledAt;
      }
      get__id_18jb1r_k$() {
        return this._id_1;
      }
      toString() {
        return 'TotpSecret(_id=' + this._id_1.toString() + ', subjectType=' + this.subjectType_1 + ', subjectId=' + this.subjectId_1 + ', label=' + this.label_1 + ', secretBase32=' + this.secretBase32__1 + ', issuer=' + this.issuer_1 + ', period=' + Duration__toString_impl_8d916b(this.period_1) + ', digits=' + this.digits_1 + ', algorithm=' + this.algorithm_1.toString() + ', establishedAt=' + this.establishedAt_1.toString() + ', lastUsedAt=' + toString(this.lastUsedAt_1) + ', expiresAt=' + toString(this.expiresAt_1) + ', disabledAt=' + toString(this.disabledAt_1) + ')';
      }
      hashCode() {
        var result = this._id_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.subjectType_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.subjectId_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.label_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.secretBase32__1) | 0;
        result = imul(result, 31) + getStringHashCode(this.issuer_1) | 0;
        result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.period_1) | 0;
        result = imul(result, 31) + this.digits_1 | 0;
        result = imul(result, 31) + this.algorithm_1.hashCode() | 0;
        result = imul(result, 31) + this.establishedAt_1.hashCode() | 0;
        result = imul(result, 31) + (this.lastUsedAt_1 == null ? 0 : this.lastUsedAt_1.hashCode()) | 0;
        result = imul(result, 31) + (this.expiresAt_1 == null ? 0 : this.expiresAt_1.hashCode()) | 0;
        result = imul(result, 31) + (this.disabledAt_1 == null ? 0 : this.disabledAt_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TotpSecret()))
          return false;
        if (!this._id_1.equals(other._id_1))
          return false;
        if (!(this.subjectType_1 === other.subjectType_1))
          return false;
        if (!(this.subjectId_1 === other.subjectId_1))
          return false;
        if (!(this.label_1 === other.label_1))
          return false;
        if (!(this.secretBase32__1 === other.secretBase32__1))
          return false;
        if (!(this.issuer_1 === other.issuer_1))
          return false;
        if (!equals(new (Duration())(this.period_1), new (Duration())(other.period_1)))
          return false;
        if (!(this.digits_1 === other.digits_1))
          return false;
        if (!this.algorithm_1.equals(other.algorithm_1))
          return false;
        if (!this.establishedAt_1.equals(other.establishedAt_1))
          return false;
        if (!equals(this.lastUsedAt_1, other.lastUsedAt_1))
          return false;
        if (!equals(this.expiresAt_1, other.expiresAt_1))
          return false;
        if (!equals(this.disabledAt_1, other.disabledAt_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_TotpSecret_rc92bb_k$(seen0, _id, subjectType, subjectId, label, secretBase32, issuer, period, digits, algorithm, establishedAt, lastUsedAt, expiresAt, disabledAt, serializationConstructorMarker) {
        Companion_getInstance_1();
        if (!(1022 === (1022 & seen0))) {
          throwMissingFieldException(seen0, 1022, $serializer_getInstance().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = Companion_getInstance_0().random_fimq0t_k$();
        else
          $this._id_1 = _id;
        $this.subjectType_1 = subjectType;
        $this.subjectId_1 = subjectId;
        $this.label_1 = label;
        $this.secretBase32__1 = secretBase32;
        $this.issuer_1 = issuer;
        $this.period_1 = period;
        $this.digits_1 = digits;
        $this.algorithm_1 = algorithm;
        $this.establishedAt_1 = establishedAt;
        if (0 === (seen0 & 1024))
          $this.lastUsedAt_1 = null;
        else
          $this.lastUsedAt_1 = lastUsedAt;
        if (0 === (seen0 & 2048))
          $this.expiresAt_1 = null;
        else
          $this.expiresAt_1 = expiresAt;
        if (0 === (seen0 & 4096))
          $this.disabledAt_1 = null;
        else
          $this.disabledAt_1 = disabledAt;
        return $this;
      }
    }
    initMetadataForClass($, 'TotpSecret', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance});
    TotpSecretClass = $;
  }
  return TotpSecretClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_2() {
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.PasswordSecret', this, 9);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('subjectType', false);
        tmp0_serialDesc.addElement_5pzumi_k$('subjectId', false);
        tmp0_serialDesc.addElement_5pzumi_k$('hash', false);
        tmp0_serialDesc.addElement_5pzumi_k$('hint', true);
        tmp0_serialDesc.addElement_5pzumi_k$('establishedAt', false);
        tmp0_serialDesc.addElement_5pzumi_k$('lastUsedAt', true);
        tmp0_serialDesc.addElement_5pzumi_k$('expiresAt', true);
        tmp0_serialDesc.addElement_5pzumi_k$('disabledAt', true);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (IndexSet())(['subjectId', 'subjectType', 'expiresAt', 'disabledAt']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_juqf22_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !value._id_1.equals(Companion_getInstance_0().random_fimq0t_k$())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, UuidSerializer_getInstance(), value._id_1);
        }
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.subjectType_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.subjectId_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 3, value.hash_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !(value.hint_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 4, StringSerializer_getInstance(), value.hint_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 5, InstantSerializer_getInstance(), value.establishedAt_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !(value.lastUsedAt_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 6, InstantSerializer_getInstance(), value.lastUsedAt_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 7) ? true : !(value.expiresAt_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 7, InstantSerializer_getInstance(), value.expiresAt_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 8) ? true : !(value.disabledAt_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 8, InstantSerializer_getInstance(), value.disabledAt_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_juqf22_k$(encoder, value instanceof PasswordSecret() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp13_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp13_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, UuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp13_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp13_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp13_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp13_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp13_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, InstantSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp13_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, InstantSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp13_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 7, InstantSerializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp13_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 8, InstantSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp13_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp13_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, UuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp13_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp13_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp13_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp13_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp13_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, InstantSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp13_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, InstantSerializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp13_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 7, InstantSerializer_getInstance(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp13_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 8, InstantSerializer_getInstance(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp13_input.endStructure_1xqz0n_k$(tmp0_desc);
        return PasswordSecret().new_com_lightningkite_lightningserver_sessions_PasswordSecret_avaw3o_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), InstantSerializer_getInstance(), get_nullable(InstantSerializer_getInstance()), get_nullable(InstantSerializer_getInstance()), get_nullable(InstantSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var PasswordSecretClass;
function PasswordSecret() {
  if (PasswordSecretClass === VOID) {
    class $ {
      constructor(_id, subjectType, subjectId, hash, hint, establishedAt, lastUsedAt, expiresAt, disabledAt) {
        _id = _id === VOID ? Companion_getInstance_0().random_fimq0t_k$() : _id;
        hint = hint === VOID ? null : hint;
        lastUsedAt = lastUsedAt === VOID ? null : lastUsedAt;
        expiresAt = expiresAt === VOID ? null : expiresAt;
        disabledAt = disabledAt === VOID ? null : disabledAt;
        this._id_1 = _id;
        this.subjectType_1 = subjectType;
        this.subjectId_1 = subjectId;
        this.hash_1 = hash;
        this.hint_1 = hint;
        this.establishedAt_1 = establishedAt;
        this.lastUsedAt_1 = lastUsedAt;
        this.expiresAt_1 = expiresAt;
        this.disabledAt_1 = disabledAt;
      }
      get__id_18jb1r_k$() {
        return this._id_1;
      }
      toString() {
        return 'PasswordSecret(_id=' + this._id_1.toString() + ', subjectType=' + this.subjectType_1 + ', subjectId=' + this.subjectId_1 + ', hash=' + this.hash_1 + ', hint=' + this.hint_1 + ', establishedAt=' + this.establishedAt_1.toString() + ', lastUsedAt=' + toString(this.lastUsedAt_1) + ', expiresAt=' + toString(this.expiresAt_1) + ', disabledAt=' + toString(this.disabledAt_1) + ')';
      }
      hashCode() {
        var result = this._id_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.subjectType_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.subjectId_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.hash_1) | 0;
        result = imul(result, 31) + (this.hint_1 == null ? 0 : getStringHashCode(this.hint_1)) | 0;
        result = imul(result, 31) + this.establishedAt_1.hashCode() | 0;
        result = imul(result, 31) + (this.lastUsedAt_1 == null ? 0 : this.lastUsedAt_1.hashCode()) | 0;
        result = imul(result, 31) + (this.expiresAt_1 == null ? 0 : this.expiresAt_1.hashCode()) | 0;
        result = imul(result, 31) + (this.disabledAt_1 == null ? 0 : this.disabledAt_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PasswordSecret()))
          return false;
        if (!this._id_1.equals(other._id_1))
          return false;
        if (!(this.subjectType_1 === other.subjectType_1))
          return false;
        if (!(this.subjectId_1 === other.subjectId_1))
          return false;
        if (!(this.hash_1 === other.hash_1))
          return false;
        if (!(this.hint_1 == other.hint_1))
          return false;
        if (!this.establishedAt_1.equals(other.establishedAt_1))
          return false;
        if (!equals(this.lastUsedAt_1, other.lastUsedAt_1))
          return false;
        if (!equals(this.expiresAt_1, other.expiresAt_1))
          return false;
        if (!equals(this.disabledAt_1, other.disabledAt_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_PasswordSecret_avaw3o_k$(seen0, _id, subjectType, subjectId, hash, hint, establishedAt, lastUsedAt, expiresAt, disabledAt, serializationConstructorMarker) {
        if (!(46 === (46 & seen0))) {
          throwMissingFieldException(seen0, 46, $serializer_getInstance_0().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = Companion_getInstance_0().random_fimq0t_k$();
        else
          $this._id_1 = _id;
        $this.subjectType_1 = subjectType;
        $this.subjectId_1 = subjectId;
        $this.hash_1 = hash;
        if (0 === (seen0 & 16))
          $this.hint_1 = null;
        else
          $this.hint_1 = hint;
        $this.establishedAt_1 = establishedAt;
        if (0 === (seen0 & 64))
          $this.lastUsedAt_1 = null;
        else
          $this.lastUsedAt_1 = lastUsedAt;
        if (0 === (seen0 & 128))
          $this.expiresAt_1 = null;
        else
          $this.expiresAt_1 = expiresAt;
        if (0 === (seen0 & 256))
          $this.disabledAt_1 = null;
        else
          $this.disabledAt_1 = disabledAt;
        return $this;
      }
    }
    initMetadataForClass($, 'PasswordSecret', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_0});
    PasswordSecretClass = $;
  }
  return PasswordSecretClass;
}
//region block: init
Companion_instance_0 = new (Companion_0())();
//endregion
//region block: exports
export {
  PasswordSecret as PasswordSecret1fpysq9jnp6wb,
  TotpSecret as TotpSecret2n8wncod0kzme,
  Companion_instance_0 as Companion_instanced3br7ruy9wqq,
  Companion_getInstance_1 as Companion_getInstance2xu56kdtu70pg,
};
//endregion

//# sourceMappingURL=AuthSecrets.mjs.map
